import React from "react";
import { CreateVideoStreamViewResult, VideoGalleryRemoteParticipant, VideoStreamOptions } from "@azure/communication-react";
import { IContextualMenuItem } from "@fluentui/react";
import { createMenuItems, CreateMenuItemsCallbacks } from "../util/createMenuItems";
import { RemoteVideoTile } from "live-lesson/shared/feature-call-ui-react";

export interface StudentVideoTileProps {
    remoteParticipant: VideoGalleryRemoteParticipant;
    menuItemCallbacks: CreateMenuItemsCallbacks;

    createRemoteStreamView:  (remoteUserId?: string, options?: VideoStreamOptions) => Promise<void | CreateVideoStreamViewResult>;
    disposeRemoteVideoStreamView(userId: string): void;
}

export const StudentVideoTile = (props: StudentVideoTileProps): JSX.Element => {
    const {
        remoteParticipant,
        menuItemCallbacks,

        createRemoteStreamView,
        disposeRemoteVideoStreamView,
    } = props;

    const menuItems: IContextualMenuItem[] = createMenuItems(
        menuItemCallbacks,
        remoteParticipant,
        undefined,
    );


    return (
        <RemoteVideoTile
            key={remoteParticipant.userId}
            remoteParticipant={remoteParticipant}
            menuItems={menuItems}

            createRemoteStreamView={createRemoteStreamView}
            disposeRemoteVideoStreamView={disposeRemoteVideoStreamView}
        />
    );
};
